import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

import Swiper from 'swiper';
import { Scrollbar } from 'swiper/modules';
// import Swiper styles
import 'swiper/css';
import 'swiper/css/scrollbar';
import { fn } from 'jquery';

gsap.registerPlugin(ScrollTrigger)
$( function() {
    scrollBoxHover();

    if(window.innerWidth < 1024) {
        var swiper = new Swiper('.swiper', {
            modules: [Scrollbar],
            slidesPerView: '1',
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
                dragSize: 50
              }
        });
    
        swiper.on("slideChange", function() {
    
            var previousIndex = swiper.activeIndex - 1;
    
            if(previousIndex < 0) {
                previousIndex = 0;
            }

            console.log(swiper.activeIndex);
    
            setTimeout(function() {
                $(".link-boxes .link-box-wrap .link-box").eq(swiper.activeIndex).find('.box-hover').addClass('active');
                $(".link-boxes .link-box-wrap .link-box").eq(previousIndex).find('.box-hover').removeClass('active');
            }, 1000);

            if(swiper.activeIndex == 0) {
                setTimeout(function() {
                    $(".link-boxes .link-box-wrap .link-box").find('.box-hover').removeClass('active');
                    $(".link-boxes .link-box-wrap .link-box").eq(0).find('.box-hover').addClass('active');

                }, 1000);
            }
    
        });
    
    }

   
});

function scrollBoxHover() {
    // Create a ScrollTrigger for the target element
    if ($(window).width() < 1024) {

        var boxes = Array.from(document.querySelectorAll('.link-box')).slice(0,1);
        boxes.forEach( box => {
            ScrollTrigger.create({
                trigger: box,
                start: 'top center', // Trigger animation when top of the element hits the center of the viewport
                end: 'bottom center', // End animation when bottom of the element hits the center of the viewport
                onEnter: () => {
                    // The target element enters the viewport
         
                    const boxHover = box.querySelector('.box-hover');
                    if (boxHover) {
                        setTimeout(() => {
                            boxHover.classList.add('active');
                        }, 1000);
                    }        
                
                },
                onLeave: () => {
                    // The target element leaves the viewport
                    const boxHover = box.querySelector('.box-hover');
                    if (boxHover) {
                        boxHover.classList.remove('active');
                    }  
                },
                // markers: true
            });
        });
    }
}
    
